import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetUserBreedersAction, userAction} from '../action';

const tableId = 'userBreedersProfile';

function* execute({payload: {tableDataRequest}}: GetUserBreedersAction): SagaIterator {
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.findLoggedInUserBreederRoles,
        successAction: userAction.getUserBreedersSuccess,
        tableId,
    }));
}
export function* getUserBreedersSaga(): SagaIterator {
    yield takeLatestF('user/GET_USER_BREEDERS', execute);
}
